import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { ArrowUpRight, Menu, X } from "lucide-react";
import { Brand } from "@/components/Brand";

const NAV_LINKS = [
  { to: "/services", label: "Services" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
  { to: "/#pricing", label: "Pricing" },
];

export default function SiteNav() {
  const [open, setOpen] = useState(false);

  const linkCls = ({ isActive }) =>
    `text-sm font-mono transition-colors ${isActive ? "text-[#8C6F1E]" : "text-neutral-700 hover:text-[#8C6F1E]"}`;

  return (
    <nav className="sticky top-0 z-40 border-b border-[#E8DFC5] bg-[#FAF7EF]/90 backdrop-blur-xl" data-testid="site-nav">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between gap-4">
        <Brand size="sm" variant="light" asLink />

        <div className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((l) =>
            l.to.startsWith("/#") ? (
              <a key={l.to} href={l.to} className="text-sm font-mono text-neutral-700 hover:text-[#8C6F1E] transition-colors">
                {l.label}
              </a>
            ) : (
              <NavLink key={l.to} to={l.to} className={linkCls}>{l.label}</NavLink>
            )
          )}
        </div>

        <div className="hidden md:flex items-center gap-2">
          <Link to="/login" data-testid="nav-login" className="px-4 py-2 text-sm font-mono border border-transparent hover:border-[#C9A961] transition-colors">Sign in</Link>
          <Link to="/register" data-testid="nav-signup" className="px-4 py-2 text-sm font-mono bg-neutral-950 text-[#D4B87D] hover:bg-[#C9A961] hover:text-neutral-950 border border-neutral-950 hover:border-[#C9A961] transition-colors flex items-center gap-1.5">
            Open workspace <ArrowUpRight className="w-3.5 h-3.5" />
          </Link>
        </div>

        <button onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle"
          className="md:hidden inline-flex items-center justify-center w-10 h-10 border border-[#C9A961] text-neutral-950">
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#E8DFC5] bg-[#FAF7EF]" data-testid="mobile-menu">
          <div className="px-6 py-4 flex flex-col divide-y divide-[#E8DFC5]">
            {NAV_LINKS.map((l) => (
              l.to.startsWith("/#") ? (
                <a key={l.to} href={l.to} onClick={() => setOpen(false)} className="py-3 font-mono text-sm text-neutral-700">{l.label}</a>
              ) : (
                <NavLink key={l.to} to={l.to} onClick={() => setOpen(false)} className="py-3 font-mono text-sm text-neutral-700">{l.label}</NavLink>
              )
            ))}
            <Link to="/login" onClick={() => setOpen(false)} className="py-3 font-mono text-sm">Sign in</Link>
            <Link to="/register" onClick={() => setOpen(false)} className="py-3 font-mono text-sm text-[#8C6F1E] flex items-center justify-between">Open workspace <ArrowUpRight className="w-4 h-4" /></Link>
          </div>
        </div>
      )}
    </nav>
  );
}
